// import config from '../utils/config';
import actionTypes from './action-types';
import tclocal from '../ter/ter-consts-local-lib';
import { actionShowToast } from '../redux/actions';
import ajax from '../utils/ajax-adapter';
import { ajax_fetch } from '../utils/frfr-ajax-fetch';
import authUtils from '../utils/auth-utils';
import { frfr_res_utils } from '../utils/frfr-res-utils';


export const errCatched = (error) => {
  // console.log(error);
  console.error(error);
}


export const actionAuthAutologin = () => {
  return (dispatch) => {
    // korak 1
    dispatch({ type: actionTypes.AUTH_AUTOLOGIN_FETCHING })
    // korak 2
    authUtils.autoLoginProcedure()
      .then((token) => {

        ajax.getAuthMyUserData(token)
          .then(response => ajax_fetch.response_json_smart(response))
          .then((response) => {
            console.log('response getAuthMyUserData AUTOLOGIN');
            console.log(response);
            // korak 3 - kad korak 2 bude success
            if (frfr_res_utils.is_srf(response)) {
              console.log(response);
              const res_payload = frfr_res_utils.srf_extract_payload(response);
              // console.log(res_payload);
              dispatch({
                type: actionTypes.AUTH_AUTOLOGIN_SUCCESS,
                payload: res_payload
              });
            } else {
              dispatch({
                type: actionTypes.AUTH_AUTOLOGIN_FAIL,
                payload: {
                  ulogovan: false,
                  role: 'GUEST'
                }
              });
            }

          })
          .catch(errCatched)

      })

  }
};


export const actionAuthFormLogin = (entbox) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({
      type: actionTypes.AUTH_FORMLOGIN_FETCHING
    });

    // korak 2 - fetchujemo podatke
    ajax.postAuthFormLogin(entbox)
      .then(response => {
        console.log(response);
        return response;
      })
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        // if (response.success === true) {
        console.log('response postAuthFormLogin');
        console.log(response);
        if (frfr_res_utils.is_srf(response)) {
          // console.log(response);
          const res_payload = frfr_res_utils.srf_extract_payload(response)
          console.log(res_payload);
          dispatch({
            type: actionTypes.AUTH_FORMLOGIN_SUCCESS,
            payload: res_payload
          });
          dispatch(actionShowToast('Sucess! DOBILI SMO TOKEN :)', tclocal.GREEN));
          // KORAK cuvanje lokalnog tokena
          let token = res_payload.token;
          authUtils.localTokenSet(token)
            .then(() => {
              authUtils.ajaxTokenSet(token);
              dispatch(actionAuthAutologin()); // AUTOLOGIN...
            });

          //
        } else if (frfr_res_utils.is_erf(response)) {
          dispatch({ type: actionTypes.AUTH_FORMLOGIN_FAIL });
          if (typeof response.error_type === 'string') {
            window.alert('GREŠKA: ' + response.error_type);
          }
          // console.log(response);
        } else {
          dispatch({ type: actionTypes.AUTH_FORMLOGIN_FAIL });
          dispatch(actionShowToast('Greska! :('));
          // console.log(response);
        }
      })
      .catch(errCatched)

  }
};

export const actionAuthLogout = (user_id) => {
  return (dispatch) => {

    authUtils.localTokenGet()
      .then((token) => {

        // BACKEND LOGOUT
        ajax.postAuthLogout(token, user_id)
          .then(response => ajax_fetch.response_json_smart(response))
          .then((response) => {
            // console.log(response);
            // Korak 3...
            if (frfr_res_utils.is_srf(response)) {
              // BACKEND LOGOUT SUCCESS

              // FRONTEND LOGOUT...
              authUtils.logoutProcedure()
                .then(() => {
                  // FRONTEND LOGOUT SUCCESS
                  dispatch({ type: actionTypes.LOGOUT_SUCCESS });
                  // redirect after logout
                  dispatch({
                    type: actionTypes.ROUTE_SET,
                    payload: 'HOME'
                  });
                  dispatch(actionShowToast('Izlogovani ste'));
                })

            }
          })
          .catch(errCatched)

      })
      .catch(errCatched)

  };
};

